import React from 'react';
import Pagify from 'react-pagify';
import segmentize from 'segmentize';
import pagifyBootstrapPreset from 'react-pagify-preset-bootstrap';
import {connect} from 'react-redux';


const _TimelinePaginator = ({
  pagination, 
  pages,
  onSelect,
  prevText, 
  nextText,
  t,

  chunkOptions : {
    changeChunkIndex,
    //chunkIndex
  },

  count,
  loading,
  chunkIndex
  
}) => {

    if(!prevText) {
        prevText = t("pagination.previous")
    }

    if(!nextText) {
        nextText = t("pagination.next")
    }

  return (

    <div className="pagination">
        <Pagify.Context
            {...pagifyBootstrapPreset}
            tags={{
                ...pagifyBootstrapPreset.tags,
                link: {
                    tag: 'span',
                    props: {style:{cursor:'pointer'}}
                }
            }}      
            className="pagination"
            segments={segmentize({
                page: pagination.page,
                pages,
                beginPages: 3,
                endPages: 3,
                sidePages: 2
            })} 
            
            onSelect={onSelect}
        >
            {/*chunkIndex > 0 &&
                <Pagify.Button onClick={()=>changeChunkIndex(chunkIndex-1)} page={false}>{'Résultats précédents'}</Pagify.Button>
            */}
            
            <Pagify.Button page={pagination.page - 1}>{prevText}</Pagify.Button>

            <Pagify.Segment field="beginPages" />

            <Pagify.Ellipsis
                className="ellipsis"
                previousField="beginPages"
                nextField="previousPages"
            />

            <Pagify.Segment field="previousPages" />
            <Pagify.Segment field="centerPage" className="active" />
            <Pagify.Segment field="nextPages" />

            <Pagify.Ellipsis
                className="ellipsis"
                previousField="nextPages"
                nextField="endPages"
            />

            <Pagify.Segment field="endPages" />
            <Pagify.Button page={pagination.page + 1}>{nextText}</Pagify.Button>
            <Pagify.Button disabled={chunkIndex < Math.ceil(count/1000)==false} onClick={()=>{
                if( chunkIndex+1 < Math.ceil(count/1000)==true) {
                    changeChunkIndex(chunkIndex+1)
                }
            }} page={1}>
                {`${t("pagination.load_more")} ${chunkIndex+1} / ${Math.ceil(count/1000)}  `} 
                {loading &&
                  <i style={{fontSize:'16px'}} className={'fa fa-spinner fa-spin'}/>
                }
            </Pagify.Button>
            
        
        </Pagify.Context>
    </div>
)};



const TimelinePaginator = connect((
    state => ({
        user:       state.auth.user,
        data:       state.timelineEvents.data,
        error:      state.timelineEvents.error,
        count:      state.timelineEvents.count,
        loading:    state.timelineEvents.loading,
        chunkIndex: state.timelineEvents.chunkIndex
    })
        
))(_TimelinePaginator);

export default TimelinePaginator;